export default __webpack_public_path__ + "static/media/profil.d2fc193a.png";